import { combineReducers } from '@reduxjs/toolkit'
import { backupReceiptPDFReducer } from './reservation-slice'
import { stayReservationsReducer } from './stay-reservation-slice'

export const reservationReducer = combineReducers({ backupReceiptPDF: backupReceiptPDFReducer, stayReservation: stayReservationsReducer })
